import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chargify/custom-ui-components';

import { DetailRow } from '../DetailRow';

export type Props = {
  /**
   * Base plan price
   */
  basePlanPrice: string;
  /**
   * Automatically resume date
   */
  autoResumeDate: string | null;
};

const OnHold = ({ basePlanPrice, autoResumeDate }: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.resume_date', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value:
            autoResumeDate ??
            t('subscription_details.resume_until_manually_restored', {
              ns: 'subscriptions-manager',
            }),
          color: 'black.main',
          fontWeight: 0,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.base_plan_price', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: basePlanPrice,
          color: 'gray.dark',
          fontWeight: 3,
        }}
      />
    </Box>
  );
};

export default OnHold;
